import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as echarts from 'echarts'
import { ref, watch, nextTick, onMounted, onUpdated, onBeforeUnmount } from 'vue'
import { throttle } from '@tri-admin/utils/src/throttle'

interface Props {
  data: echarts.EChartsOption
  loading?: boolean
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetChart' },
  __name: 'widget-chart',
  props: {
    data: { default: () => ({ title: {}, xAxis: { show: true }, yAxis: { show: true }, tooltip: { show: true }, series: [] }) },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

let instance: echarts.EChartsType | null

const loadingStyle = {
  text: '',
  color: 'var(--el-color-primary)',
  maskColor: 'var(--el-overlay-color)',
  showSpinner: true,
  spinnerRadius: 18,
  lineWidth: 3,
}
const chartRef = ref<HTMLDivElement | null>(null) // DOM容器


// 初始化图标
const createEchart = () => {
  if (!chartRef.value || echarts.getInstanceByDom(chartRef.value)) return
  const element = chartRef.value
  instance = echarts.init(element, {}, { renderer: 'svg' })
  props.loading && instance.showLoading(loadingStyle)
  instance.setOption(props.data)
}

// 更新图表配置
const updateEchart = (options: echarts.EChartsOption) => {
  if (!instance) return
  instance.setOption(options)
}

// 窗口改变更新图标
const resizeEchart = throttle(function () {
  instance && instance.resize()
})

watch(
  () => props.loading,
  (now, old) => {
    if (now === old || typeof now !== 'boolean') return
    if (!instance || now) return
    instance.hideLoading()
  },
  { immediate: true }
)

// 初始化
onMounted(async () => {
  await nextTick()
  createEchart()
  window.addEventListener('resize', resizeEchart, false) // 窗口大小改变事假监听
})

onUpdated(async () => {
  await nextTick()
  instance ? updateEchart(props.data) : createEchart()
})

onBeforeUnmount(() => {
  window.removeEventListener('online', resizeEchart)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartRef",
    ref: chartRef,
    class: "tri-chart"
  }, null, 512))
}
}

})